export const LOADER_TYPES = {
    DEFAULT_LOADER: 'DEFAULT_LOADER',
    NOTIFICATION_LOADER: 'NOTIFICATION_LOADER',
    LOCALIZATION_LOADER: 'LOCALIZATION_LOADER',
};
